<template>
  <div class="payments-list-wrapper">
    <Header @selectall="selectall"/>
    <div class="fixed-row"
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="loadCheck"
      infinite-scroll-throttle-delay="400"
      infinite-scroll-distance="10">
      <div v-if="!isLoading">
        <Row
          v-for="payment in payments"
          :selectedAll="selectedAll"
          :payment="payment"
          :depots="depots"
          :delivery_type="delivery_type"
          :movement="movement"
          :specialPickupGate="specialPickupGate"
          :state="state"
          :key="payment.id"
          @select="select" />
      </div>
      <span v-else>Loading ...</span>
      <div class="no-data" v-if="!isLoading && !payments.length">
        No records found for bill generation
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import Header from '@/components/payment/list/Header';
import Row from '@/components/payment/list/Row';
import PayFilter from '../../common/payFilter';

export default {
  components: { Header, Row, PayFilter },

  props: {
    selectedDepot: {},
    loadCheck: true,
  },

  data() {
    return {
      selectedAll: false,
      selected: [],
      canCreateInvoice: false,
      delivery_type: null,
      movement: null,
      state: null,
      specialPickupGate: null,
    };
  },

  computed: {
    ...mapGetters({
      isLoading: 'payment/isLoading',
      payments: 'payment/list',
      depots: 'app/depots',
    }),
    ...mapState({
      invoiceFilter: state => state.payment.invoiceFilter,
      seletedIndentType: state => state.payment.indentType,
      seletedVehicleType: state => state.payment.vehicleType,
      selectedInvoiceType: state => state.payment.invoiceType,
    }),
  },

  created() {
    this.fetch();
    this.$store.showInvoice = false;
    this.$store.showNote = false;
    this.$store.invoice = null;
    this.$store.invoiceId = null;
  },

  methods: {
    loadMore() {
      this.$emit('loadData');
    },
    fetch() {
      const clients = this.$store.state.app.data.clients;
      if (clients.length > 0) {
        const filter = {
          client_id: clients[0].id,
        };
        if (this.seletedIndentType.id) {
          filter.filter_type = this.seletedIndentType.id;
        }
        if (this.seletedVehicleType.id) {
          filter.delivery_type = this.seletedVehicleType.id;
        }
        if (this.selectedDepot) {
          filter.depot_id = this.selectedDepot;
        }
        filter.page = 1;
        this.$store.dispatch('payment/filter', filter);
        this.$store.payments = {
          selected: [],
        };
      }
    },

    selectall(status) {
      this.selectedAll = status;
    },

    select(payment) {
      const { $store: { payments: { selected } } } = this;
      const index = selected.indexOf(payment);
      if (index === -1) {
        selected.push(payment);
      } else {
        selected.splice(index, 1);
      }
      // Not to club GTA and NON GTA
      if (selected.length === 0) {
        this.delivery_type = null;
        this.movement = null;
        this.state = null;
        this.specialPickupGate = null;
      } else if (selected.length === 1) {
        const [firstitem] = selected;
        this.delivery_type = firstitem.delivery_type;
        this.movement = firstitem.movement;
        this.state = firstitem.depot_id;
        this.specialPickupGate = firstitem.special_pickup_gate !== null ? firstitem.special_pickup_gate._id : '-';
      }
      this.$emit('select');
    },
  },


};
</script>
<style lang='scss'>
.fixed-row {
  position: fixed;
  padding-right: 10px;
  top: 170px;
  left: 20px;
  right: 10px;
  bottom: 0;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
